import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { css, styled } from 'styled-components';
import { ifProp } from 'styled-tools';

const ArrowIcon = styled(FontAwesomeIcon)<{ $isOpen: boolean }>`
  ${({ theme, $isOpen }) => css`
    font-size: 0.75rem;
    transform: ${$isOpen ? 'rotateZ(90deg)' : 'rotateZ(0deg)'};
    transition: transform 0.3s ease-in-out;
    ${ifProp(
      '$isOpen',
      css`
        color: ${theme.colors.primaryRed};
        transform-style: preserve-3d;
      `
    )}
  `}
`;

export default ArrowIcon;
